"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("../style");
var _Icon = require("../../Icon");
var _colors = require("../../style/colors");
var _keyCode = require("../keyCode");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ButtonItem extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleKeydown = event => {
      let flag = false;
      switch (event.keyCode) {
        case this.keyCode.SPACE:
        case this.keyCode.RETURN:
          {
            const {
              item: {
                onItemClick
              }
            } = this.props;
            if (onItemClick) {
              onItemClick();
              flag = true;
            }
          }
          break;
        default:
          break;
      }
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    };
    this.handleClick = () => {
      this.item.focus();
    };
    this.state = {
      tabIndex: '-1'
    };
    this.keyCode = _keyCode.keyCode;
    this.handleKeydown = this.handleKeydown.bind(this);
  }
  componentDidMount() {
    this.item.addEventListener('click', this.handleClick);
    this.item.addEventListener('keydown', this.handleKeydown);
  }
  componentDidUpdate(prevProps) {
    if (this.props.shouldFocus) {
      this.updateTabIndexIfNeeded(prevProps);
    }
  }
  componentWillUnmount() {
    this.item.removeEventListener('click', this.handleClick);
    this.item.removeEventListener('keydown', this.handleKeydown);
  }
  setFocusToItem() {
    const {
      shouldFocus
    } = this.props;
    const newTabIndex = shouldFocus ? '0' : '-1';
    if (shouldFocus) {
      this.item.focus();
    }
    this.setState({
      tabIndex: newTabIndex
    });
  }
  updateTabIndexIfNeeded(prevProps) {
    if (prevProps.shouldFocus !== this.props.shouldFocus) {
      this.setFocusToItem();
    }
  }
  render() {
    const {
      item: {
        type,
        title,
        onItemClick,
        icon,
        selected,
        disabled,
        colors,
        tag
      },
      ariaHaspopup
    } = this.props;
    const hasIcon = !!icon || !!selected;
    return /*#__PURE__*/_react.default.createElement(_style.ButtonItemStyled, {
      ref: item => this.item = item,
      type: "button",
      role: "menuitem",
      fullWidth: true,
      onKeyDown: ev => this.handleKeydown(ev),
      onClick: event => {
        if (onItemClick) onItemClick();
        event.stopPropagation();
        event.preventDefault();
      },
      tabIndex: this.state.tabIndex,
      "aria-haspopup": ariaHaspopup,
      disabled: disabled,
      colors: colors
    }, selected && /*#__PURE__*/_react.default.createElement(_Icon.Checkmark, {
      color: _colors.green
    }), icon || null, /*#__PURE__*/_react.default.createElement(_style.ButtonLabel, {
      hasIcon: hasIcon,
      type: type
    }, title), tag || null);
  }
}
exports.default = ButtonItem;
ButtonItem.propTypes = {
  shouldFocus: _propTypes.default.bool,
  ariaHaspopup: _propTypes.default.bool,
  index: _propTypes.default.number.isRequired,
  item: _propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    colors: _propTypes.default.shape({
      title: _propTypes.default.string,
      iconHover: _propTypes.default.string
    })
  }).isRequired
};
ButtonItem.defaultProps = {
  shouldFocus: false,
  ariaHaspopup: false
};